import { render, staticRenderFns } from "./all-payment.vue?vue&type=template&id=01cb54fd&scoped=true"
import script from "./all-payment.vue?vue&type=script&lang=js"
export * from "./all-payment.vue?vue&type=script&lang=js"
import style0 from "./all-payment.vue?vue&type=style&index=0&id=01cb54fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb54fd",
  null
  
)

export default component.exports